export default __webpack_public_path__ + "static/media/ic_arrow_right.ba704c14431cceff59e3956dad4a047e.svg";